import React, { useContext, useState } from "react";

import { Money } from "../../../components";
import { UserContext } from "../../../contexts";
import { Visible } from "../../../core/components";

import ProductDetails from "./ProductDetails";
import ProductImage from "./ProductImage";
import OrderAddress from "./OrderAddress";
import OrderInfo from "./OrderInfo";
import AdminActions from "./AdminActions";
import ClientActions from "./ClientActions";

const ItemProduct = ({
  order,
  item,
  manage,
  last,
  open,
  summary = false,
  onClick,
  hideActionButton = false,
}) => {
  const { user } = useContext(UserContext);
  const [newStatus, setNewStatus] = useState(null);

  const sectionProps = { user, order, item, manage, open, last };

  return (
    <div
      key={item?.id}
      className={`${last ? "" : "toggleable"} ${open ? "open" : "close"}`}
      onClick={onClick}
    >
      <div className="row" key={item?.id}>
        <ProductImage {...sectionProps} />

        <div className="order-details row">
          <ProductDetails {...{ ...sectionProps, newStatus, summary }} />

          <Visible when={last}>
            <OrderInfo {...sectionProps} />
            <OrderAddress {...sectionProps} />
          </Visible>

          {/*
            Round 8 audit: ACTION dropdown + Price (AdminActions /
            ClientActions) belong in the rightmost column. They were
            previously rendering at the last position correctly, but
            visually appeared mid-row because of `.col-last` flex/order
            CSS. Reverted to original JSX order — last child of the
            order-details row — so they sit in the rightmost slot
            where the empty space is in Cart Orders.
          */}
          <Visible when={!summary && !hideActionButton}>
            <Visible
              when={
                !user?.is_admin &&
                !manage &&
                (last || order.status?.indexOf("deposit") > -1)
              }
            >
              <ClientActions {...sectionProps} />
            </Visible>

            <Visible when={user?.is_admin}>
              <AdminActions {...{ ...sectionProps, setNewStatus }} />
            </Visible>
          </Visible>

          <Visible when={summary || hideActionButton}>
            <div className="col-last item-col top-border">
              <div className="position-bottom">
                <div className="amount">
                  <Money amount={open ? item?.price : order.total_amount} currency={order.currency} />
                </div>
              </div>
            </div>
          </Visible>

          <div className="toggleable-bottom-border" />
        </div>
      </div>
    </div>
  );
};

export default ItemProduct;
